// @vendors
const get = require('lodash/object/get');

// @helpers
const apiURLBuilder = require('../core/apiURLBuilder');
const actionTypes = require('constants/actionTypes');
const {
    FIRST_STEP,
    SECOND_STEP,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP,
    BROKER_CONDITIONAL_ORDER_TERM,
    EURO_TEXT,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ORDER_TYPE_TO_MARKET,
    FOR_THE_BEST_ORDER_CLASS,
    LIMITED_ORDER_CLASS,
    TO_MARKET_ORDER_CLASS,
    BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID,
    BROKER_SYSTEM_NAME,
    BROKER_ALERT_BUY_BUTTON_STOCK,
    BROKER_TYPE_STOCKS_NEW_DECIMALS_ROUNDER
} = require('constants/index');

// @utilities
const { APIPost } = require('utilities/APIRequestHelper');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');
const { brokerStocksOperationFailure } = require('actions/brokerStocksOperationFailure');

function reset() {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_RESET
    };
}

function setVisibleStep(step) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function setWillCancel(value) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_WILL_CANCEL,
        payload: {
            value
        }
    };
}

function validateUIStep(step, catalogData) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_VALIDATE_UI_STEP,
        payload: {
            step,
            catalogData
        }
    };
}

function validateWithAPISuccess(step, response) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_VALIDATE_SUCCESS,
        payload: {
            data: response,
            step
        }
    };
}

function validateWithAPIFailure(step, response) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_VALIDATE_FAILURE,
        payload: {
            data: response,
            step
        }
    };
}

function validateWithAPIRequest(step) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_VALIDATE_REQUEST,
        payload: {
            step
        }
    };
}

const getValidationRequestObject = getState => {
    const immStocksContract = getState().brokerStocksContract;
    const immBrokerStocksAdvancedSell = getState().brokerStocksAdvancedSell;

    const step1 = immBrokerStocksAdvancedSell.getIn(['steps', FIRST_STEP]);
    const step2 = immBrokerStocksAdvancedSell.getIn(['steps', SECOND_STEP]);
    const validityDate = step1.get('validityDate');
    const selectedOptionValue = step2.get('selectedOptionValue');
    const selectedStockContract = immStocksContract.find(contract => {
        return contract.get('contactNumber') === selectedOptionValue;
    });

    if (!selectedStockContract) {
        return;
    }

    const orderTypeOption = step2.get('orderTypeOption');
    const orderTypeValue = step2.get('orderTypeValue');
    const titleQuantity = step2.get('titleQuantity');
    const isin = immBrokerStocksAdvancedSell.get('isin');
    const iso = immBrokerStocksAdvancedSell.get('iso');

    const requestObject = {
        query: {
            codigoISIN: isin,
            codigoISO: iso,
            contratoValores: {
                numerodecontrato: selectedStockContract.get('walletNumber'),
                producto: selectedStockContract.get('productNumber')
            },
            digitoControlCCV: selectedStockContract.get('controlDigit'),
            fechaLimite: validityDate.format('YYYY-MM-DD'),
            importeAproximado: {
                divisa: EURO_TEXT,
                numeroimportevalores: 0
            },
            titulos: titleQuantity
        }
    };

    switch (orderTypeOption) {
        case BROKER_ORDER_TYPE_FOR_THE_BEST:
            requestObject.query.clase = FOR_THE_BEST_ORDER_CLASS;
            break;
        case BROKER_ORDER_TYPE_LIMITED:
            requestObject.query.clase = LIMITED_ORDER_CLASS;
            requestObject.query.precioLimitada = orderTypeValue;
            break;
        case BROKER_ORDER_TYPE_TO_MARKET:
            requestObject.query.clase = TO_MARKET_ORDER_CLASS;
            break;
    }

    return requestObject;
};

const validateConditionalOrderWithAPI = (step, history) => (dispatch, getState) => {
    const valid = getState().brokerStocksAdvancedSell.getIn(['steps', FIRST_STEP, 'valid']);

    if (valid) {
        const data = getValidationRequestObject(getState);

        dispatch(validateWithAPIRequest(step));
        return APIPost(
            dispatch,
            apiURLBuilder.getURL('brokerConditionalStocksSellValidation'),
            data
        ).then(
            function(response) {
                dispatch(validateWithAPISuccess(step, response));
            },
            function(response) {
                dispatch(validateWithAPIFailure(step, response));
                const errorKey = get(response, ['body', 'error'], '');
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
            }
        );
    }
};

const validateRestrictedOrderWithAPI = () => {
    //TODO: implement me !
};

const validateWithAPI = (orderTerms, step, history) => dispatch => {
    if (orderTerms === BROKER_CONDITIONAL_ORDER_TERM) {
        dispatch(validateConditionalOrderWithAPI(step, history));
    } else {
        dispatch(validateRestrictedOrderWithAPI());
    }
};

function signaturePatternSuccess(token) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_SIGNATURE_SUCCESS,
        payload: {
            token
        }
    };
}

function confirmStocksSellRequest() {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_CONFIRM_REQUEST
    };
}

function confirmStocksSellSuccess() {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_CONFIRM_SUCCESS
    };
}

function confirmStocksSellFailure(response) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_CONFIRM_FAILURE,
        payload: {
            data: response
        }
    };
}

function getConfirmationRequestObject(getState) {
    //Hardcoded service params
    //TODO: move to constants file if they are needed somewhere else
    const NUM_EJECUCIONES = 1;
    const ID_ACCION = 'VOS';
    const TIPO_EJECUCION = 0;
    const TIPO_OPERACION = 'V';
    const TIPO_PRECIO = 'T';

    const immStocksContract = getState().brokerStocksContract;
    const immBrokerStocksAdvancedSell = getState().brokerStocksAdvancedSell;
    const immBrokerProductFile = getState().brokerProductFile;
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');

    const step1 = immBrokerStocksAdvancedSell.getIn(['steps', FIRST_STEP]);
    const step2 = immBrokerStocksAdvancedSell.getIn(['steps', SECOND_STEP]);
    const validationServiceResponse = immBrokerStocksAdvancedSell.get('validationServiceResponse');
    const productCurrency = immBrokerStocksAdvancedSell.get('productCurrency');
    const selectedOptionValue = step2.get('selectedOptionValue');
    const selectedStockContract = immStocksContract.find(contract => {
        return contract.get('contactNumber') === selectedOptionValue;
    });

    if (!selectedStockContract) {
        return;
    }

    const orderTypeOption = step2.get('orderTypeOption');
    const orderTypeValue = step2.get('orderTypeValue');
    const titleQuantity = step2.get('titleQuantity');
    const conditionType = step1.get('conditionType');
    const conditionTypeValue = step1.get('conditionTypeValue');
    const marketCode = step1.get('exchangeId');
    const stockLast = immBrokerProductFile.getIn(['productValue','amount']);
    const spcSymbol = immBrokerProductFile.get('spcSymbol');
    const validityDate = step1.get('validityDate');
    const codigoDisclaimer = getState().brokerMiFIDProducts.getIn(['products', BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID, 'codigoDisclaimer']);
    const shares = validationServiceResponse.get('numTitulos');

    const requestObject = {
        header: {
            'version': 2
        },
        query: {
            codEmis: validationServiceResponse.get('codigoEmision'),
            codGrupoSector: validationServiceResponse.get('codGrupoSector'),
            codMercado: marketCode,
            codOrganismoEjecucion: validationServiceResponse.get('codOrganismoEjecucion').trim(),
            codOrganismoFusion: validationServiceResponse.get('codOrganismoFusion').trim(),
            codVaint: validationServiceResponse.get('codigoValor'),
            codValorSibCodVLBOL: validationServiceResponse.get('codValorSibCodVLBOL'),
            codigoMoneda: validationServiceResponse.get('codigoMoneda'),
            contratoValores: {
                numerodecontrato: selectedStockContract.get('walletNumber'),
                producto: selectedStockContract.get('productNumber')
            },
            dataToken: immBrokerStocksAdvancedSell.get('signaturePatternToken'),
            digControCCV: selectedStockContract.get('controlDigit'),
            fechaVencimiento: validityDate.format('YYYY-MM-DD'),
            idAccion: ID_ACCION,
            idCondicion: conditionType,
            identifiMercadoContratacion: validationServiceResponse
                .get('identifiMercadoContratacion')
                .trim(),
            importeAproximado: {
                divisa: EURO_TEXT,
                importe: 0
            },
            indCompras: validationServiceResponse.get('indCompras'),
            indEnvioRecepcion: validationServiceResponse.get('indEnvioRecepcion'),
            indNegocio: validationServiceResponse.get('indNegocio'),
            indTratamientoEmisor: validationServiceResponse.get('indTratamientoEmisor'),
            numEjecuciones: NUM_EJECUCIONES,
            numTitulos: titleQuantity,
            precio: stockLast,
            unitPrice: stockLast,
            simboloEmision: spcSymbol.trim(),
            sistema: BROKER_SYSTEM_NAME,
            tipoCotizacion: validationServiceResponse.get('tipoCotizacion'),
            tipoEjecucion: TIPO_EJECUCION,
            tipoMercado: validationServiceResponse.get('tipoMercado'),
            tipoOperacion: TIPO_OPERACION,
            tipoPrecio: TIPO_PRECIO,
            valorCondicion: parseFloat(Math.round(conditionTypeValue * BROKER_TYPE_STOCKS_NEW_DECIMALS_ROUNDER) / BROKER_TYPE_STOCKS_NEW_DECIMALS_ROUNDER).toFixed(3),
            valorJuntaSindical: validationServiceResponse.get('valorJuntaSindical'),
            precioLimitada: {
                divisa: 'EUR',
                numeroimportevalores: 0
            },
            shares: shares,
            initQuantity: shares,
            convenienceTest: codigoDisclaimer,
            productIsin: immBrokerStocksAdvancedSell.get('isin'),
            micCode: immBrokerStocksAdvancedSell.get('iso'),
            productManager: getState().brokerProductFile.get('manager'),
            disclaimers: {
                disclaimer_1: "",
                disclaimer_2: "",
                disclaimer_3: "",
                disclaimer_4: "",
                disclaimer_5: ""
            },
            convenientRegistry: false,
            evaluateRegistry: false,
            marketTargetRegistry: false,
            necessaryConvenienceTestNote: 0,
            necessaryTargetMarketNote: "",
            testConveniencyResult: 0,
            productType: BROKER_ALERT_BUY_BUTTON_STOCK,
            documentationId: uuid
        }
    };

    switch (orderTypeOption) {
        case BROKER_ORDER_TYPE_FOR_THE_BEST:
            requestObject.query.indOrdenBolsa = FOR_THE_BEST_ORDER_CLASS;
            break;
        case BROKER_ORDER_TYPE_LIMITED:
            requestObject.query.indOrdenBolsa = LIMITED_ORDER_CLASS;
            break;
        case BROKER_ORDER_TYPE_TO_MARKET:
            requestObject.query.indOrdenBolsa = TO_MARKET_ORDER_CLASS;
            break;
    }

    if (orderTypeOption === BROKER_ORDER_TYPE_LIMITED) {
        requestObject.query.precioLimitada = {
            divisa: productCurrency,
            numeroimportevalores: orderTypeValue
        };
    }

    return requestObject;
}

function confirmStocksSell(history) {
    return function(dispatch, getState) {
        const data = getConfirmationRequestObject(getState);

        dispatch(confirmStocksSellRequest());
        return APIPost(
            dispatch,
            apiURLBuilder.getURL('brokerConditionalStocksBuyConfirmation'),
            data
        ).then(
            function() {
                dispatch(confirmStocksSellSuccess());
                dispatch(outdateGlobalPosition());
                dispatch(outdateMyInvestments());
            },
            function(response) {
                dispatch(confirmStocksSellFailure(response));
                dispatch(brokerStocksOperationFailure(response, history));
            }
        );
    };
}

const requestSignaturePatternValidation = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(signaturePatternSuccess(dataToken));
        dispatch(confirmStocksSell(history));
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const finish = (history) => dispatch => {
    dispatch(requestSignaturePatternValidation(history));
};

const validateStep = (step, history) => (dispatch, getState) => {
    const catalogData = getState().brokerProductFile.get('catalogData');
    dispatch(validateUIStep(step, catalogData));
    if (step === WIZARD_SECOND_STEP) {
            if (getState().brokerStocksAdvancedSell.getIn(['steps', SECOND_STEP, 'valid'])) {
                const orderTerms = getState().brokerStocksAdvancedSell.getIn([
                    'steps',
                    FIRST_STEP,
                    'orderTerms'
                ]);
                dispatch(validateWithAPI(orderTerms, step, history));
            }
    }
    else if (step === WIZARD_THIRD_STEP) {
        dispatch(finish(history));
    }
};

function orderTermsChanged(value) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_ORDER_TERMS_CHANGED,
        payload: {
            value
        }
    };
}

const inputSearchProductSelected = product => {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_INPUT_SEARCH_PRODUCT_SELECTED,
        payload: {
            currencyCode: product.currencyCode,
            value: product.value,
            isin: product.id.isin,
            iso: product.id.iso,
            spcSymbol: product.spcSymbol,
            last: product.last,
            exchangeId: product.exchangeId
        }
    };
};

const orderConditionValueChanged = value => {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_ORDER_CONDITION_VALUE_CHANGED,
        payload: {
            value
        }
    };
};

const conditionTypeChanged = value => {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_ORDER_CONDITION_TYPE_CHANGED,
        payload: {
            value
        }
    };
};

const conditionTypeValueChanged = value => {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_CONDITION_TYPE_VALUE_CHANGED,
        payload: {
            value
        }
    };
};

const validityDateChanged = value => {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_VALIDITY_DATE_CHANGED,
        payload: {
            value
        }
    };
};

const orderTermValidityDateChanged = value => {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_ORDER_TERM_VALIDITY_DATE_CHANGED,
        payload: {
            value
        }
    };
};

function stockContractChanged(value, titles) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_STOCK_CONTRACT_CHANGED,
        payload: {
            value,
            titles
        }
    };
}

function titleQuantityChanged(value, manually) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_TITLE_QUANTITY_CHANGED,
        payload: {
            value,
            manually
        }
    };
}

function orderTypeChanged(value) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_ORDER_TYPE_CHANGED,
        payload: {
            value
        }
    };
}

function limitedValueChanged(value) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_LIMITED_VALUE_CHANGED,
        payload: {
            value
        }
    };
}

function setLimitedValueCurrency(value) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_SET_LIMITED_VALUE_CURRENCY,
        payload: {
            value
        }
    };
}

function setOrderID(isin, iso) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_SELL_SET_ORDER_ID,
        payload: {
            isin,
            iso
        }
    };
}

module.exports = {
    reset,
    setVisibleStep,
    setWillCancel,
    validateStep,
    finish,
    orderTermsChanged,
    inputSearchProductSelected,
    orderConditionValueChanged,
    conditionTypeChanged,
    conditionTypeValueChanged,
    validityDateChanged,
    orderTermValidityDateChanged,
    stockContractChanged,
    titleQuantityChanged,
    orderTypeChanged,
    limitedValueChanged,
    setLimitedValueCurrency,
    setOrderID
};
